export default "__VITE_ASSET__CqY457OH__"